import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'sonder-form-legend',
  templateUrl: './form-legend.component.html',
  styleUrls: ['./form-legend.component.scss'],
  standalone: false
})
export class FormLegendComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

  @Input() disabled = false;
  @Input() inline = false;

  get classToggles() {
    return {
      'sm-disabled': this.disabled,
      '-inline': this.inline
    };
  }
}
